import { render, staticRenderFns } from "./CrewAssignmentAlertCard.vue?vue&type=template&id=6b15fc82&scoped=true"
import script from "./CrewAssignmentAlertCard.vue?vue&type=script&lang=js"
export * from "./CrewAssignmentAlertCard.vue?vue&type=script&lang=js"
import style0 from "./CrewAssignmentAlertCard.vue?vue&type=style&index=0&id=6b15fc82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b15fc82",
  null
  
)

export default component.exports